module.exports = __webpack_public_path__ + "static/img/1.195036c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/eng/1.png
// module id = XbgC
// module chunks = 0